import { AssistantPromptResultType, AssistantSearchResult } from '@mews-commander/data-access';
import { AssistantNavigation } from './navigation/AssistantNavigation';
import { MergedSearchAndNavigationResult } from './ResultListAndNavigations';

export const getMergeSearchResultAndNavigation = (
    searchResult: AssistantSearchResult | null | undefined,
    navigations: AssistantNavigation[]
): MergedSearchAndNavigationResult => ({
    chatId: searchResult?.chatId || '',
    parentChatId: searchResult?.parentChatId || '',
    resultType: AssistantPromptResultType.SearchResult,
    reservations: searchResult?.reservations || [],
    companies: searchResult?.companies || [],
    bills: searchResult?.bills || [],
    customers: searchResult?.customers || [],
    productServiceOrders: searchResult?.productServiceOrders || [],
    travelAgencies: searchResult?.travelAgencies || [],
    reservationGroups: searchResult?.reservationGroups || [],
    resourceBlocks: searchResult?.resourceBlocks || [],
    resources: searchResult?.resources || [],
    availabilityBlocks: searchResult?.availabilityBlocks || [],
    routingRules: searchResult?.routingRules || [],
    navigations,
});
